import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../filters';

export default {
  name: 'master_details_grids',
  components: {
    DataGridComp: require('./datagrid.vue').default,
  },
  props: {
    main_data_source: {
      type: Array,
      required: true
    },
    main_cols: {
      type: Array,
      required: true
    },
    sub: {
      type: Array,
      required: true
    },
    masterKeyCol: {
      type: String
    },
    childKeyCol: {
      type: String
    }
  },
  data: function () {
    return {
      filterd_data_source: [],
      activeFilters: [],
      masterKeyColumn: ''
    }
  },
  computed: {

  },
  methods: {
    filtered(info) {
      this.filterd_data_source = [];

      let mainGridRowData = info.selectedRowsData;

      for (var i = 0; i < this.sub.length; i++) {
        var filtered = this.sub[i].data_source;

        this.sub[i].args.forEach(filter => {
          filtered = filtered.filter(record => {
            return filter.sub_col === mainGridRowData[0][filter.main_col]
              ? new RegExp(mainGridRowData[0][filter.main_col], 'i').test(record[filter.sub_col])
              : record[filter.sub_col] == mainGridRowData[0][filter.main_col]
          })

          if (filtered.length > 0)
            this.filterd_data_source.push({ 'datasource': filtered, 'idx': i });
        })
      }
    },
    getTitle(idx) {
      var title = '';

      if (Object.keys(this.sub[idx]).includes('title'))
        title = this.sub[idx].title;

      return title;
    }
  },
}
